import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_47557304 from 'nuxt_plugin_plugin_47557304' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_portalvue_233115a7 from 'nuxt_plugin_portalvue_233115a7' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginsfloatingvue6840394c_a9570ce4 from 'nuxt_plugin_pluginsfloatingvue6840394c_a9570ce4' // Source: ./plugins.floating-vue.6840394c.js (mode: 'all')
import nuxt_plugin_pluginsdirectives45580567_69ba0a9c from 'nuxt_plugin_pluginsdirectives45580567_69ba0a9c' // Source: ./plugins.directives.45580567.js (mode: 'all')
import nuxt_plugin_tooltip_cac20f68 from 'nuxt_plugin_tooltip_cac20f68' // Source: ../plugins/tooltip (mode: 'all')
import nuxt_plugin_velocity_5d794fc3 from 'nuxt_plugin_velocity_5d794fc3' // Source: ../plugins/velocity.js (mode: 'client')
import nuxt_plugin_spinner_6719da62 from 'nuxt_plugin_spinner_6719da62' // Source: ../plugins/spinner (mode: 'all')
import nuxt_plugin_nuxtclientinit_37cfbfdf from 'nuxt_plugin_nuxtclientinit_37cfbfdf' // Source: ../plugins/nuxt-client-init (mode: 'all')
import nuxt_plugin_interceptors_7fad4776 from 'nuxt_plugin_interceptors_7fad4776' // Source: ../plugins/interceptors (mode: 'all')
import nuxt_plugin_filters_a8b86778 from 'nuxt_plugin_filters_a8b86778' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_vuemodaldialogs_708fc60d from 'nuxt_plugin_vuemodaldialogs_708fc60d' // Source: ../plugins/vue-modal-dialogs (mode: 'all')
import nuxt_plugin_vuesanitize_f79153b2 from 'nuxt_plugin_vuesanitize_f79153b2' // Source: ../plugins/vue-sanitize (mode: 'all')
import nuxt_plugin_datepicker_eb580154 from 'nuxt_plugin_datepicker_eb580154' // Source: ../plugins/date-picker (mode: 'all')
import nuxt_plugin_tailwindConfig_6f66a55e from 'nuxt_plugin_tailwindConfig_6f66a55e' // Source: ../plugins/tailwindConfig (mode: 'all')
import nuxt_plugin_feedback_471f4151 from 'nuxt_plugin_feedback_471f4151' // Source: ../plugins/feedback.ts (mode: 'all')
import nuxt_plugin_services_4606f135 from 'nuxt_plugin_services_4606f135' // Source: ../plugins/services (mode: 'all')
import nuxt_plugin_meta_598eade0 from 'nuxt_plugin_meta_598eade0' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"microclaudia","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_47557304 === 'function') {
    await nuxt_plugin_plugin_47557304(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_233115a7 === 'function') {
    await nuxt_plugin_portalvue_233115a7(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsfloatingvue6840394c_a9570ce4 === 'function') {
    await nuxt_plugin_pluginsfloatingvue6840394c_a9570ce4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsdirectives45580567_69ba0a9c === 'function') {
    await nuxt_plugin_pluginsdirectives45580567_69ba0a9c(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltip_cac20f68 === 'function') {
    await nuxt_plugin_tooltip_cac20f68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_velocity_5d794fc3 === 'function') {
    await nuxt_plugin_velocity_5d794fc3(app.context, inject)
  }

  if (typeof nuxt_plugin_spinner_6719da62 === 'function') {
    await nuxt_plugin_spinner_6719da62(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtclientinit_37cfbfdf === 'function') {
    await nuxt_plugin_nuxtclientinit_37cfbfdf(app.context, inject)
  }

  if (typeof nuxt_plugin_interceptors_7fad4776 === 'function') {
    await nuxt_plugin_interceptors_7fad4776(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_a8b86778 === 'function') {
    await nuxt_plugin_filters_a8b86778(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemodaldialogs_708fc60d === 'function') {
    await nuxt_plugin_vuemodaldialogs_708fc60d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesanitize_f79153b2 === 'function') {
    await nuxt_plugin_vuesanitize_f79153b2(app.context, inject)
  }

  if (typeof nuxt_plugin_datepicker_eb580154 === 'function') {
    await nuxt_plugin_datepicker_eb580154(app.context, inject)
  }

  if (typeof nuxt_plugin_tailwindConfig_6f66a55e === 'function') {
    await nuxt_plugin_tailwindConfig_6f66a55e(app.context, inject)
  }

  if (typeof nuxt_plugin_feedback_471f4151 === 'function') {
    await nuxt_plugin_feedback_471f4151(app.context, inject)
  }

  if (typeof nuxt_plugin_services_4606f135 === 'function') {
    await nuxt_plugin_services_4606f135(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_598eade0 === 'function') {
    await nuxt_plugin_meta_598eade0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
